import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import {action, computed} from 'mobx';
import {inject} from 'mobx-react';
import {Link} from 'react-router';

import {withI18n} from 'spa/Components/Context';

import ProgressiveBackgroundImage from 'spa/Components/ProgressiveBackgroundImage';
import ProgressiveImage from 'spa/Components/ProgressiveImage';

import 'spa/styles/home.less';
import '../../Home/HomeTreatmentsSection.less';

@inject(({store: {screen, tracker}}) => ({
  screen,
  tracker,
}))
@withI18n
class HomeTreatmentsSectionForDigital extends React.Component {
  static propTypes = {
    screen: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }),
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
  };

  @autobind
  @action('onClickBrowseTherapists - HomeTreatmentsSectionForDigital')
  onClickBrowseTherapists() {
    const trackingData = {
      category: this.props.trackingCategory,
      label: 'Browse Therapists',
    };

    if (this.props.trackingLocation) {
      trackingData.data = {
        page: this.props.trackingLocation,
      };
    }

    this.props.tracker.track('Clicked Browse Therapists button', trackingData);
  }

  @computed get brandsSectionContent() {
    const {i18n} = this.context;

    if (i18n.umRegion === 'UK') {
      return (
        <React.Fragment>
          <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">Before they can join the Urban community, we check each therapist’s paperwork, knowledge and equipment, including their hygiene practices.</p>
          <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">And in case you’re wondering, Urban pros are known for being really nice people – something <a className="home-content-section__paragraph home-content-section-for-digital__paragraph home-content-section-for-digital__link" href="https://uk.trustpilot.com/review/urban.co" target="_blank" rel="noopener noreferrer">our Trustpilot reviews</a> can vouch for.</p>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">{i18n._x('We make sure that all Urban therapists are qualified and covered by professional insurance. We only partner with those who are experts in their field and able to offer you high quality care.', 'Home treatments section paragraph')}</p>
      </React.Fragment>
    );
  }

  render() {
    const {i18n} = this.context;
    const {screen: {isDesktop}} = this.props;
    const {brandsSectionContent} = this;

    return (
      <div className="home-treatments-section home-content-section row">
        <ProgressiveBackgroundImage
          customClass="home-content-section__cell home-content-section__cell-image home-content-section-for-digital__cell-image home-treatments-section__cell-image"
          lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1644312493/b2c-art/home-2022/home-third.jpg"
          highResImg=""
          highResImg2x=""
          mediaQueries={[
            {
              query: '(max-width: 768px)',
              highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_1440/v1644312493/b2c-art/home-2022/home-third.jpg',
              highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_2160/v1644312493/b2c-art/home-2022/home-third.jpg',
            },
          ]}
        >
          {isDesktop && (
            <ProgressiveImage
              className="home-treatments-section__cell-image-element"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1644312493/b2c-art/home-2022/home-third.jpg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_1440/v1644312493/b2c-art/home-2022/home-third.jpg"
              highResImg2x="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_2160/v1644312493/b2c-art/home-2022/home-third.jpg"
            />
          )}
        </ProgressiveBackgroundImage>

        <div className="home-content-section__cell home-content-section__cell-text home-content-section__cell-text--extra-padded-right">
          <div className="home-content-section__text-content home-content-section__text-content--wide">
            <h2 className="home-content-section__title home-content-section-for-digital__title">{i18n._x('Therapists you can trust', 'Home treatments section title')}</h2>
            {brandsSectionContent}
            {i18n.umRegion === 'UK' ? (
              <Link
                className="button button--primary button--tiny-wide home-content-section__button home-content-section-for-digital__button"
                data-qa="home-tailored-section-button"
                onClick={this.onClickBrowseTherapists}
                to={`/${i18n.lc}/therapists`}
              >
                {i18n._x('Find a therapist', 'Homepage browse therapists button')}
              </Link>
            ) : (
              <a
                className="button button--primary button--tiny-wide home-content-section__button home-content-section-for-digital__button"
                data-qa="home-tailored-section-button"
                href="https://urban.co/fr-fr/editorial/contribuons-au-bon-deroulement-des-soins-a-domicile/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n._x('Check our security measures', 'Homepage browse therapists button')}
              </a>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default HomeTreatmentsSectionForDigital;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/HomeTreatmentsSectionForDigital.jsx